// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App shell: light sidebar, slim header, content panel, footer (see docs/ADMIN_DESIGN_GUIDE.md) */

/* ---------- Sidebar ---------- */
.ant-layout-sider.app-sider {
  position: sticky;
  top: 0;
  height: 100vh;
  background: #f1f5f9;
  border-right: 1px solid #d6dee8;
}

.app-sider .ant-layout-sider-children {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px 12px 12px;
  overflow-x: hidden;
  overflow-y: auto;
}

.ant-layout-sider.app-sider .ant-layout-sider-trigger {
  height: 48px;
  line-height: 48px;
  color: #64748b;
  background: #ffffff;
  border-top: 1px solid #d6dee8;
}

.app-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  min-height: 52px;
  margin-bottom: 20px;
  padding: 8px 10px;
  background: #ffffff;
  border: 1px solid #d6dee8;
  border-radius: 10px;
}

.app-sider.ant-layout-sider-collapsed .app-brand {
  justify-content: center;
  padding: 8px 0;
}

.app-brand-logo {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.app-brand-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.25;
}

.app-brand-name {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
}

.app-brand-sub {
  font-size: 12px;
  color: #64748b;
}

/* Menu: transparent on the tinted sidebar, active item is a white pill */
.app-sider .app-menu.ant-menu {
  flex: 1 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #d6dee8 transparent;
  background: transparent;
  border-inline-end: 0;
  border-right: 0;
}

.app-sider .app-menu.ant-menu-inline,
.app-sider .app-menu.ant-menu-inline-collapsed {
  border-right: 0;
}

.app-sider .app-menu.ant-menu-inline-collapsed {
  width: 100%;
}

.app-sider .app-menu .ant-menu-item,
.app-sider .app-menu .ant-menu-submenu-title {
  height: 36px;
  margin: 0 0 4px;
  padding-right: 12px;
  line-height: 36px;
  font-weight: 500;
  color: #64748b;
  border-radius: 8px;
}

.app-sider .app-menu.ant-menu-inline .ant-menu-item,
.app-sider .app-menu.ant-menu-inline .ant-menu-submenu-title {
  width: 100%;
}

.app-sider .app-menu .ant-menu-item a,
.app-sider .app-menu .ant-menu-item a:hover {
  color: inherit;
}

.app-sider .app-menu .ant-menu-item:hover,
.app-sider .app-menu .ant-menu-submenu-title:hover {
  color: #0f172a;
  background: rgba(255, 255, 255, 0.6);
}

.app-sider .app-menu .ant-menu-submenu:hover > .ant-menu-submenu-title,
.app-sider .app-menu .ant-menu-submenu-active > .ant-menu-submenu-title,
.app-sider .app-menu .ant-menu-submenu-open > .ant-menu-submenu-title {
  color: #0f172a;
}

/* antd 4 draws a coloured bar on the right of the active inline item */
.app-sider .app-menu.ant-menu-inline .ant-menu-item::after {
  display: none;
}

.app-sider .app-menu .ant-menu-item-selected {
  font-weight: 600;
  color: #0f172a;
  background: #ffffff;
  box-shadow: inset 0 0 0 1px #d6dee8, 0 1px 2px 0 rgba(15, 23, 42, 0.05);
}

.app-sider .app-menu .ant-menu-item-selected a {
  color: #0f172a;
}

.app-sider .app-menu .ant-menu-submenu-selected > .ant-menu-submenu-title {
  font-weight: 600;
  color: #0f172a;
}

.app-sider .app-menu .ant-menu-item-group-title {
  padding: 12px 12px 6px;
  font-size: 12px;
  font-weight: 500;
  color: #94a3b8;
}

.app-sider .app-menu .ant-menu-item-group:first-child > .ant-menu-item-group-title {
  padding-top: 0;
}

.app-sider .app-menu .ant-menu-item-group + .ant-menu-item-group {
  margin-top: 8px;
  padding-top: 4px;
  border-top: 1px solid #d6dee8;
}

.app-sider .app-menu .ant-menu-item-group-list .ant-menu-item,
.app-sider .app-menu .ant-menu-item-group-list .ant-menu-submenu-title {
  padding-left: 12px;
}

.app-sider .app-menu .ant-menu-sub.ant-menu-inline {
  background: transparent;
}

.app-sider .app-menu .ant-menu-submenu-arrow {
  color: #94a3b8;
}

.app-sider .app-menu .ant-menu-item .anticon,
.app-sider .app-menu .ant-menu-submenu-title .anticon {
  font-size: 16px;
}

/* Collapsed (icon-only) rail */
.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-item,
.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-submenu-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0 !important;
}

.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-item .anticon,
.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-submenu-title .anticon {
  margin: 0 !important;
  line-height: 1;
}

/* Groups: no labels in the rail (the divider stays), and the group wrappers fill the rail */
.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-item-group-title {
  display: none;
}

.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-item-group,
.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-item-group-list {
  width: 100%;
  padding-top: 0;
}

.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-item-group + .ant-menu-item-group {
  padding-top: 12px;
}

/* The router <Link> lives in the label: keep it and stretch it invisibly over the whole item. */
.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-item {
  position: relative;
}

.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-item .ant-menu-item-icon + span,
.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-item .ant-menu-title-content {
  position: absolute !important;
  inset: 0;
  display: block !important;
  width: 100% !important;
  max-width: none !important;
  margin: 0 !important;
  overflow: hidden;
  opacity: 0 !important;
}

.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-item a {
  display: block;
  width: 100%;
  height: 100%;
}

.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-submenu-title .ant-menu-title-content,
.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-submenu-title .ant-menu-item-icon + span,
.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-submenu-title .ant-menu-submenu-arrow {
  display: none !important;
}

/* Popup (flyout) submenus when the rail is collapsed */
.ant-menu-submenu-popup .ant-menu-vertical.ant-menu-sub {
  padding: 4px;
  border-radius: 10px;
}

.ant-menu-submenu-popup .ant-menu-item {
  border-radius: 8px;
}

.ant-menu-submenu-popup .ant-menu-item:hover {
  color: #0f172a;
  background: #f1f5f9;
}

.ant-menu-submenu-popup .ant-menu-item-selected {
  font-weight: 600;
  color: #0f172a;
  background: #e9eef4;
}

.ant-menu-submenu-popup .ant-menu-item a {
  color: inherit;
}

.app-sider .app-menu.ant-menu::-webkit-scrollbar {
  width: 6px;
}

.app-sider .app-menu.ant-menu::-webkit-scrollbar-thumb {
  background: #d6dee8;
  border-radius: 4px;
}

/* Profile block pinned to the bottom of the sidebar */
.app-user {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  gap: 8px;
  margin-top: 16px;
  padding: 8px;
  background: #ffffff;
  border: 1px solid #d6dee8;
  border-radius: 10px;
}

.app-sider.ant-layout-sider-collapsed .app-user {
  justify-content: center;
  padding: 6px 0;
}

.app-user-profile {
  display: flex;
  flex: 1 1;
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding: 0;
  text-align: left;
  cursor: pointer;
  background: transparent;
  border: 0;
}

.app-sider.ant-layout-sider-collapsed .app-user-profile {
  flex: 0 0 auto;
  justify-content: center;
}

.app-user-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.25;
}

.app-user-name {
  overflow: hidden;
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.app-user-role {
  font-size: 12px;
  color: #64748b;
}

.app-icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  color: #64748b;
  cursor: pointer;
  background: transparent;
  border: 0;
  border-radius: 8px;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.app-icon-button:hover {
  color: #b91c1c;
  background: #fee2e2;
}

/* ---------- Layout: top bar and footer stay put, only the content scrolls ---------- */
.ant-layout.app-root {
  height: 100vh;
  overflow: hidden;
}

.ant-layout.app-main-layout {
  height: 100vh;
  min-height: 0;
  overflow: hidden;
}

.ant-layout-header.app-header,
.ant-layout-footer.app-footer {
  flex-shrink: 0;
}

/* ---------- Header ---------- */
.ant-layout-header.app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  height: 64px;
  padding: 0 24px;
  line-height: normal;
  background: #ffffff;
  border-bottom: 1px solid #d6dee8;
}

.app-header-slot {
  display: flex;
  flex: 1 1;
  align-items: center;
  min-width: 0;
}

.app-page-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  min-width: 0;
}

.app-page-header-crumbs .ant-breadcrumb {
  font-size: 12px;
  line-height: 16px;
}

.app-page-header-title {
  min-width: 0;
}

.app-page-header-heading {
  margin: 0;
  overflow: hidden;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.01em;
  color: #0f172a;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.app-header-user {
  display: flex;
  align-items: center;
  gap: 12px;
}

.app-header-user-text {
  display: flex;
  flex-direction: column;
  text-align: right;
  line-height: 1.3;
}

.app-header-user-name {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
}

.app-header-user-role {
  font-size: 12px;
  color: #64748b;
}

.app-header-avatar {
  display: inline-flex;
  padding: 0;
  line-height: 0;
  cursor: pointer;
  background: transparent;
  border: 1px solid #d6dee8;
  border-radius: 50%;
  transition: border-color 0.15s ease;
}

.app-header-avatar:hover {
  border-color: #64748b;
}

.app-avatar.ant-avatar {
  color: #ffffff;
  background: #1e293b;
}

/* ---------- Content ---------- */
.ant-layout-content.app-content {
  flex: 1 1;
  min-height: 0;
  padding: 24px;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #d6dee8 transparent;
}

.ant-layout-content.app-content::-webkit-scrollbar {
  width: 8px;
}

.ant-layout-content.app-content::-webkit-scrollbar-thumb {
  background: #d6dee8;
  border-radius: 4px;
}

.app-content-panel {
  min-height: 100%;
  padding: 24px;
  background: #ffffff;
  border: 1px solid #d6dee8;
  border-radius: 12px;
  box-shadow: 0 1px 2px 0 rgba(15, 23, 42, 0.05);
}

.app-page-breadcrumb.ant-breadcrumb {
  font-size: 13px;
}

.app-page-breadcrumb .ant-breadcrumb-link,
.app-page-breadcrumb .ant-breadcrumb-link a,
.app-page-breadcrumb .ant-breadcrumb-separator {
  color: #94a3b8;
}

.app-page-breadcrumb > span:last-child .ant-breadcrumb-link {
  font-weight: 500;
  color: #0f172a;
}

/* The page header moved to the top bar, so the divider that used to sit under it is a stray line. */
.app-content-panel .content-pane-transaction-div-style > .ant-divider-horizontal:first-child,
.app-content-panel > div > .ant-divider-horizontal:first-child {
  display: none;
}

/* ---------- Footer ---------- */
.ant-layout-footer.app-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 48px;
  padding: 0 24px;
  font-size: 12px;
  color: #64748b;
  background: #ffffff;
  border-top: 1px solid #d6dee8;
}

.app-footer-sep {
  color: #94a3b8;
}

.app-footer a {
  color: #64748b;
}

.app-footer a:hover {
  color: #0f172a;
}

@media (max-width: 576px) {
  .ant-layout-header.app-header {
    padding: 0 16px;
  }

  .ant-layout-content.app-content {
    padding: 16px;
  }

  .app-content-panel {
    padding: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/appShell.css"],"names":[],"mappings":"AAAA,kGAAkG;;AAElG,kCAAkC;AAClC;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;EACpC,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,oCAAoC;AACtC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,uEAAuE;AACzE;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,cAAc;AAChB;;AAEA,4FAA4F;AAC5F;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gGAAgG;AAChG;EACE,kBAAkB;AACpB;;AAEA;;EAEE,6BAA6B;EAC7B,QAAQ;EACR,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA,uDAAuD;AACvD;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,wFAAwF;AACxF;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oGAAoG;AACpG;;EAEE,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* App shell: light sidebar, slim header, content panel, footer (see docs/ADMIN_DESIGN_GUIDE.md) */\n\n/* ---------- Sidebar ---------- */\n.ant-layout-sider.app-sider {\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  background: #f1f5f9;\n  border-right: 1px solid #d6dee8;\n}\n\n.app-sider .ant-layout-sider-children {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 16px 12px 12px;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.ant-layout-sider.app-sider .ant-layout-sider-trigger {\n  height: 48px;\n  line-height: 48px;\n  color: #64748b;\n  background: #ffffff;\n  border-top: 1px solid #d6dee8;\n}\n\n.app-brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n  min-height: 52px;\n  margin-bottom: 20px;\n  padding: 8px 10px;\n  background: #ffffff;\n  border: 1px solid #d6dee8;\n  border-radius: 10px;\n}\n\n.app-sider.ant-layout-sider-collapsed .app-brand {\n  justify-content: center;\n  padding: 8px 0;\n}\n\n.app-brand-logo {\n  width: 32px;\n  height: 32px;\n  object-fit: contain;\n}\n\n.app-brand-text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  line-height: 1.25;\n}\n\n.app-brand-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0f172a;\n  white-space: nowrap;\n}\n\n.app-brand-sub {\n  font-size: 12px;\n  color: #64748b;\n}\n\n/* Menu: transparent on the tinted sidebar, active item is a white pill */\n.app-sider .app-menu.ant-menu {\n  flex: 1;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #d6dee8 transparent;\n  background: transparent;\n  border-inline-end: 0;\n  border-right: 0;\n}\n\n.app-sider .app-menu.ant-menu-inline,\n.app-sider .app-menu.ant-menu-inline-collapsed {\n  border-right: 0;\n}\n\n.app-sider .app-menu.ant-menu-inline-collapsed {\n  width: 100%;\n}\n\n.app-sider .app-menu .ant-menu-item,\n.app-sider .app-menu .ant-menu-submenu-title {\n  height: 36px;\n  margin: 0 0 4px;\n  padding-right: 12px;\n  line-height: 36px;\n  font-weight: 500;\n  color: #64748b;\n  border-radius: 8px;\n}\n\n.app-sider .app-menu.ant-menu-inline .ant-menu-item,\n.app-sider .app-menu.ant-menu-inline .ant-menu-submenu-title {\n  width: 100%;\n}\n\n.app-sider .app-menu .ant-menu-item a,\n.app-sider .app-menu .ant-menu-item a:hover {\n  color: inherit;\n}\n\n.app-sider .app-menu .ant-menu-item:hover,\n.app-sider .app-menu .ant-menu-submenu-title:hover {\n  color: #0f172a;\n  background: rgba(255, 255, 255, 0.6);\n}\n\n.app-sider .app-menu .ant-menu-submenu:hover > .ant-menu-submenu-title,\n.app-sider .app-menu .ant-menu-submenu-active > .ant-menu-submenu-title,\n.app-sider .app-menu .ant-menu-submenu-open > .ant-menu-submenu-title {\n  color: #0f172a;\n}\n\n/* antd 4 draws a coloured bar on the right of the active inline item */\n.app-sider .app-menu.ant-menu-inline .ant-menu-item::after {\n  display: none;\n}\n\n.app-sider .app-menu .ant-menu-item-selected {\n  font-weight: 600;\n  color: #0f172a;\n  background: #ffffff;\n  box-shadow: inset 0 0 0 1px #d6dee8, 0 1px 2px 0 rgba(15, 23, 42, 0.05);\n}\n\n.app-sider .app-menu .ant-menu-item-selected a {\n  color: #0f172a;\n}\n\n.app-sider .app-menu .ant-menu-submenu-selected > .ant-menu-submenu-title {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.app-sider .app-menu .ant-menu-item-group-title {\n  padding: 12px 12px 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #94a3b8;\n}\n\n.app-sider .app-menu .ant-menu-item-group:first-child > .ant-menu-item-group-title {\n  padding-top: 0;\n}\n\n.app-sider .app-menu .ant-menu-item-group + .ant-menu-item-group {\n  margin-top: 8px;\n  padding-top: 4px;\n  border-top: 1px solid #d6dee8;\n}\n\n.app-sider .app-menu .ant-menu-item-group-list .ant-menu-item,\n.app-sider .app-menu .ant-menu-item-group-list .ant-menu-submenu-title {\n  padding-left: 12px;\n}\n\n.app-sider .app-menu .ant-menu-sub.ant-menu-inline {\n  background: transparent;\n}\n\n.app-sider .app-menu .ant-menu-submenu-arrow {\n  color: #94a3b8;\n}\n\n.app-sider .app-menu .ant-menu-item .anticon,\n.app-sider .app-menu .ant-menu-submenu-title .anticon {\n  font-size: 16px;\n}\n\n/* Collapsed (icon-only) rail */\n.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-item,\n.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-submenu-title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 0 !important;\n}\n\n.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-item .anticon,\n.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-submenu-title .anticon {\n  margin: 0 !important;\n  line-height: 1;\n}\n\n/* Groups: no labels in the rail (the divider stays), and the group wrappers fill the rail */\n.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-item-group-title {\n  display: none;\n}\n\n.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-item-group,\n.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-item-group-list {\n  width: 100%;\n  padding-top: 0;\n}\n\n.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-item-group + .ant-menu-item-group {\n  padding-top: 12px;\n}\n\n/* The router <Link> lives in the label: keep it and stretch it invisibly over the whole item. */\n.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-item {\n  position: relative;\n}\n\n.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-item .ant-menu-item-icon + span,\n.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-item .ant-menu-title-content {\n  position: absolute !important;\n  inset: 0;\n  display: block !important;\n  width: 100% !important;\n  max-width: none !important;\n  margin: 0 !important;\n  overflow: hidden;\n  opacity: 0 !important;\n}\n\n.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-item a {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-submenu-title .ant-menu-title-content,\n.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-submenu-title .ant-menu-item-icon + span,\n.app-sider.ant-layout-sider-collapsed .app-menu .ant-menu-submenu-title .ant-menu-submenu-arrow {\n  display: none !important;\n}\n\n/* Popup (flyout) submenus when the rail is collapsed */\n.ant-menu-submenu-popup .ant-menu-vertical.ant-menu-sub {\n  padding: 4px;\n  border-radius: 10px;\n}\n\n.ant-menu-submenu-popup .ant-menu-item {\n  border-radius: 8px;\n}\n\n.ant-menu-submenu-popup .ant-menu-item:hover {\n  color: #0f172a;\n  background: #f1f5f9;\n}\n\n.ant-menu-submenu-popup .ant-menu-item-selected {\n  font-weight: 600;\n  color: #0f172a;\n  background: #e9eef4;\n}\n\n.ant-menu-submenu-popup .ant-menu-item a {\n  color: inherit;\n}\n\n.app-sider .app-menu.ant-menu::-webkit-scrollbar {\n  width: 6px;\n}\n\n.app-sider .app-menu.ant-menu::-webkit-scrollbar-thumb {\n  background: #d6dee8;\n  border-radius: 4px;\n}\n\n/* Profile block pinned to the bottom of the sidebar */\n.app-user {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n  gap: 8px;\n  margin-top: 16px;\n  padding: 8px;\n  background: #ffffff;\n  border: 1px solid #d6dee8;\n  border-radius: 10px;\n}\n\n.app-sider.ant-layout-sider-collapsed .app-user {\n  justify-content: center;\n  padding: 6px 0;\n}\n\n.app-user-profile {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  padding: 0;\n  text-align: left;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n}\n\n.app-sider.ant-layout-sider-collapsed .app-user-profile {\n  flex: 0 0 auto;\n  justify-content: center;\n}\n\n.app-user-text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  line-height: 1.25;\n}\n\n.app-user-name {\n  overflow: hidden;\n  font-size: 13px;\n  font-weight: 600;\n  color: #0f172a;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.app-user-role {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.app-icon-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  color: #64748b;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.app-icon-button:hover {\n  color: #b91c1c;\n  background: #fee2e2;\n}\n\n/* ---------- Layout: top bar and footer stay put, only the content scrolls ---------- */\n.ant-layout.app-root {\n  height: 100vh;\n  overflow: hidden;\n}\n\n.ant-layout.app-main-layout {\n  height: 100vh;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.ant-layout-header.app-header,\n.ant-layout-footer.app-footer {\n  flex-shrink: 0;\n}\n\n/* ---------- Header ---------- */\n.ant-layout-header.app-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  height: 64px;\n  padding: 0 24px;\n  line-height: normal;\n  background: #ffffff;\n  border-bottom: 1px solid #d6dee8;\n}\n\n.app-header-slot {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  min-width: 0;\n}\n\n.app-page-header {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 4px;\n  min-width: 0;\n}\n\n.app-page-header-crumbs .ant-breadcrumb {\n  font-size: 12px;\n  line-height: 16px;\n}\n\n.app-page-header-title {\n  min-width: 0;\n}\n\n.app-page-header-heading {\n  margin: 0;\n  overflow: hidden;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.01em;\n  color: #0f172a;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.app-header-user {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.app-header-user-text {\n  display: flex;\n  flex-direction: column;\n  text-align: right;\n  line-height: 1.3;\n}\n\n.app-header-user-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.app-header-user-role {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.app-header-avatar {\n  display: inline-flex;\n  padding: 0;\n  line-height: 0;\n  cursor: pointer;\n  background: transparent;\n  border: 1px solid #d6dee8;\n  border-radius: 50%;\n  transition: border-color 0.15s ease;\n}\n\n.app-header-avatar:hover {\n  border-color: #64748b;\n}\n\n.app-avatar.ant-avatar {\n  color: #ffffff;\n  background: #1e293b;\n}\n\n/* ---------- Content ---------- */\n.ant-layout-content.app-content {\n  flex: 1;\n  min-height: 0;\n  padding: 24px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #d6dee8 transparent;\n}\n\n.ant-layout-content.app-content::-webkit-scrollbar {\n  width: 8px;\n}\n\n.ant-layout-content.app-content::-webkit-scrollbar-thumb {\n  background: #d6dee8;\n  border-radius: 4px;\n}\n\n.app-content-panel {\n  min-height: 100%;\n  padding: 24px;\n  background: #ffffff;\n  border: 1px solid #d6dee8;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px 0 rgba(15, 23, 42, 0.05);\n}\n\n.app-page-breadcrumb.ant-breadcrumb {\n  font-size: 13px;\n}\n\n.app-page-breadcrumb .ant-breadcrumb-link,\n.app-page-breadcrumb .ant-breadcrumb-link a,\n.app-page-breadcrumb .ant-breadcrumb-separator {\n  color: #94a3b8;\n}\n\n.app-page-breadcrumb > span:last-child .ant-breadcrumb-link {\n  font-weight: 500;\n  color: #0f172a;\n}\n\n/* The page header moved to the top bar, so the divider that used to sit under it is a stray line. */\n.app-content-panel .content-pane-transaction-div-style > .ant-divider-horizontal:first-child,\n.app-content-panel > div > .ant-divider-horizontal:first-child {\n  display: none;\n}\n\n/* ---------- Footer ---------- */\n.ant-layout-footer.app-footer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 48px;\n  padding: 0 24px;\n  font-size: 12px;\n  color: #64748b;\n  background: #ffffff;\n  border-top: 1px solid #d6dee8;\n}\n\n.app-footer-sep {\n  color: #94a3b8;\n}\n\n.app-footer a {\n  color: #64748b;\n}\n\n.app-footer a:hover {\n  color: #0f172a;\n}\n\n@media (max-width: 576px) {\n  .ant-layout-header.app-header {\n    padding: 0 16px;\n  }\n\n  .ant-layout-content.app-content {\n    padding: 16px;\n  }\n\n  .app-content-panel {\n    padding: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
